import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=62000a2f"
var script = {}
import style0 from "./AboutView.vue?vue&type=style&index=0&id=62000a2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports